import { templatize } from '@polymer/polymer/lib/utils/templatize.js';

export const template = {
    stampAndReplace: (templateElement, initData) => {
        if (!templateElement) return null;

        const templateInstance = templatize(templateElement);
        const templateStamp = new templateInstance(initData);
        const frag = templateStamp.root;

        // Replace the <template> itself with the stamped content so the position in HTML is kept.
        templateElement.replaceWith(frag);

        return frag;
    }
};